import { Paper } from "@material-ui/core";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  width: 100%;
`;

export const HeaderTitle = styled.h1`
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #031795;
`;

export const CloseButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FormContent = styled.form`
  display: flex;
  flex: 1;
  width: 100%;
  padding-top: 16px;
  gap: 16px;
  max-height: 100vh;
  flex-direction: column;
`;

export const FieldsSection = styled.section`
  display: flex;
  flex: 1;
  width: 100%;
  padding-top: 16px;
  gap: 16px;
  max-height: 100vh;
  flex-direction: column;
`;

export const AccessModelCard = styled(Paper)`
  padding: 16px;
  display: flex;
  flex-direction: column;
`;

export const CardColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  min-height: calc(100vh - 200px);
`;

export const AccessCard = styled(Paper)`
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ParticipantsCard = styled(Paper)`
  padding: 16px;
  display: flex;
  /* max-height: 572px; */
  height: 100%;
  overflow: auto;
  flex-direction: column;
`;

export const UserSelectionContainer = styled.div`
  display: grid;
  width: 100%;
`;

export const CardTitle = styled.h2`
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #031795;
`;

export const AccessCheckboxList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  overflow: auto;
  margin-top: 16px;
`;

export const SearchAccessInputContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const CardSubTitle = styled.h2`
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  color: #031795;
`;

export const AccessModelContainer = styled.div`
  padding-left: 8px;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  padding-top: 16px;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 8px;
`;
